import Cookies from 'js-cookie';
import { axiosManager } from '../../axios-manager';
import AttachmentCRUDProps from './index.d';

class AttachmentCRUD {
  private readonly token;

  constructor() {
    this.token = Cookies.get('token') || '';
  }

  create({ attachment, id, type }: AttachmentCRUDProps.createParams) {
    const data = new FormData();
    
    let paramType: string;     

    switch(type) {
      case 'talent_pool':
        paramType = "talent_pool_id"
        break;
      case 'applicant':
        paramType = 'applicant_id'
        break;
      case 'corporate_client':
        paramType = 'corporate_client_id'
        break;
      case 'personal_client':
      default: 
        paramType = 'personal_client_id'
        break;
    }

    if (attachment) data.append('attachment', attachment);
    if(paramType && id) data.append(paramType, id.toString());

    return axiosManager<AttachmentCRUDProps.createReturn>({
      method: 'post',
      url: `/attachment/create`,
      auth: this.token,
      payload: data,
    });
  }

  read({ type, id, page = 1, per_page = 5 }: AttachmentCRUDProps.readParams) {
    let urlType: string;     

    switch(type) {
      case 'talent_pool':
        urlType = "talent_pool_id"
        break;
      case 'applicant':
        urlType = 'applicant_id'
        break;
      case 'corporate_client':
        urlType = 'corporate_client_id'
        break;
      case 'personal_client':
      default: 
        urlType = 'personal_client_id'
        break;
    }
    let url = `/attachment/list?${urlType}=${id}&per_page=${per_page}`;
    if(page !== 1) url = url + `&page=${page}`

    return axiosManager<AttachmentCRUDProps.readReturn>({
      method: 'get',
      url,
      auth: this.token,
      payload: null,
    });
  }

  delete({ id }: AttachmentCRUDProps.deleteParams) {
    return axiosManager<AttachmentCRUDProps.deleteReturn>({
      method: 'delete',
      url: `/attachment/delete/${id}`,
      auth: this.token,
      payload: null,
    });
  }
}

export { AttachmentCRUD };
